import { render, staticRenderFns } from "./Director.vue?vue&type=template&id=39db1521&scoped=true"
import script from "./Director.vue?vue&type=script&lang=js"
export * from "./Director.vue?vue&type=script&lang=js"
import style0 from "./Director.vue?vue&type=style&index=0&id=39db1521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db1521",
  null
  
)

export default component.exports